"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusMixin = void 0;
var _styledToken = _interopRequireDefault(require("styled-token"));
/** @mixin focusMixin */
/**
 * Add custom focus styling to the component.
 *
 * @example
 * import { focusMixin } from '@zillow/constellation';
 *
 * const Component = styled.button`
 *     ${focusMixin}
 * `;
 *
 * <Component>Custom focus styling</Component>
 *
 * @method
 */
var focusMixin = function focusMixin(props) {
  return "\n    outline: none;\n    box-shadow: none;\n    &:focus-visible {\n        box-shadow: " + ((0, _styledToken.default)('shadows.focus')(props) || '') + ";\n    }\n    @supports not selector(:focus-visible) {\n        &:focus {\n            box-shadow: " + ((0, _styledToken.default)('shadows.focus')(props) || '') + ";\n        } \n    }\n";
};
exports.focusMixin = focusMixin;